/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  // get({ searchKey }) {
  //   const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
  //   return axios.get(url);
  // }

  get({ searchKey, inboxId } = {}) {
    const params = {};
    if (searchKey) params.search = searchKey;
    if (inboxId) params.inbox_id = inboxId;

    return axios.get(this.url, { params });
  }
}

export default new CannedResponse();
